import { render, staticRenderFns } from "./ModuleFour.vue?vue&type=template&id=01f1f6e7&scoped=true"
import script from "./ModuleFour.vue?vue&type=script&lang=js"
export * from "./ModuleFour.vue?vue&type=script&lang=js"
import style0 from "./ModuleFour.vue?vue&type=style&index=0&id=01f1f6e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f1f6e7",
  null
  
)

export default component.exports